import request from '../request/request';

const getPermissionByDrn = data => {
  return request(
    {
      url: '/webapi/auth/batch-authz',
      method: 'post',
      data
    },
    false
  );
};

// eslint-disable-next-line import/prefer-default-export
export { getPermissionByDrn };
